import { createTheme, Alert, Tabs, Paper } from '@mantine/core';
import alertStyles from './Alert.module.scss';
import tabsStyles from './Tabs.module.scss';
import paperStyles from './Paper.module.scss';

export const TammilanitTheme = createTheme({
    /** White color */
    white: '#f3f3f9',

    /** Black color */
    black: '#0f1b06',

    colors: {
        violet:
            ['#0f0b14', '#2e213c','#4d3864', '#6c4e8b', '#8b64b3', '#9a6fc7', '#ae8cd2', '#c2a9dd', '#e1d4ee', '#f5f1f9'],
    },

    components: {
        Alert: Alert.extend({
            classNames: {
                root: alertStyles.root,
                title: alertStyles.title,
                body: alertStyles.body,
                message: alertStyles.message,
            }
        }),
        Tabs: Tabs.extend({
            classNames: {
                root: tabsStyles.root,
                tab: tabsStyles.tab,
                list: tabsStyles.list
            }
        }),
        Paper: Paper.extend({
            classNames: {
                root: paperStyles.root,
            }
        }),
    },
});
